import React from 'react';
import PageLayout from '../app/layout/PageLayout';
import SlabLogo from '../components/SlabLogo';
import * as styles from './AccountContentContainer.module.scss';

interface AccountContentContainerProps {
  children?: React.ReactNode;
  subtitle?: string;
  title?: string;
}

const AccountContentContainer = ({
  children,
  subtitle,
  title,
}: AccountContentContainerProps) => (
  <PageLayout.Content noPaddingY className={styles.container}>
    <div className={styles.innerContainer}>
      <div className={styles.main}>
        <SlabLogo className={styles.logo} />
        {title && (
          <header className={styles.header}>
            <h2>{title}</h2>
            {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
          </header>
        )}
        {children}
      </div>
    </div>
  </PageLayout.Content>
);

AccountContentContainer.Divider = () => <div className={styles.divider} />;
AccountContentContainer.ButtonInstruction = (
  props: Omit<React.HTMLAttributes<HTMLDivElement>, 'className'>,
) => <div {...props} className={styles.buttonInstruction} />;

export default AccountContentContainer;
